import braSizeEquivalences from '../json/bra-size-wireless-equivalences.json';
import braSizes from '../json/bra-sizes.json';

export type Unit = 'inches' | 'centimeters';

const convertToInches = (value: number) =>
  Math.round((value / 2.54) * 100) / 100;

const convertToCentimeters = (value: number) =>
  Math.round(value * 2.54 * 100) / 100;

export const calculateBraSize = (
  underbust: number,
  overbust: number,
  unit: Unit
) => {
  if (unit === 'centimeters') {
    underbust = convertToInches(underbust);
    overbust = convertToInches(overbust);
  }

  for (const data of braSizes) {
    const [minUnderbust, maxUnderbust] = data.underbust;
    const [minOverbust, maxOverbust] = data.overbust;

    if (
      underbust >= minUnderbust &&
      underbust <= maxUnderbust &&
      overbust >= minOverbust &&
      overbust <= maxOverbust
    ) {
      return data.size;
    }
  }

  return null;
};

export const getEquivalentWirelessSize = (wiredBraSize: string) =>
  braSizeEquivalences[wiredBraSize];

const roundUp = (value: number) => Math.ceil(value * 10) / 10;
const roundDown = (value: number) => Math.floor(value * 10) / 10;

const underbustMinInches = Math.min(...braSizes.map(size => size.underbust[0]));
const underbustMaxInches = Math.max(...braSizes.map(size => size.underbust[1]));

const overbustMinInches = Math.min(...braSizes.map(size => size.overbust[0]));
const overbustMaxInches = Math.max(...braSizes.map(size => size.overbust[1]));

const underbustMinCms = roundUp(convertToCentimeters(underbustMinInches));
const underbustMaxCms = roundDown(convertToCentimeters(underbustMaxInches));

const overbustMinCms = roundUp(convertToCentimeters(overbustMinInches));
const overbustMaxCms = roundDown(convertToCentimeters(overbustMaxInches));

export const getMeasurementLimitsByUnit = (unit: Unit) => {
  if (unit === 'inches') {
    return {
      underbustMin: underbustMinInches,
      underbustMax: underbustMaxInches,
      overbustMin: overbustMinInches,
      overbustMax: overbustMaxInches,
    };
  } else {
    return {
      underbustMin: underbustMinCms,
      underbustMax: underbustMaxCms,
      overbustMin: overbustMinCms,
      overbustMax: overbustMaxCms,
    };
  }
};
